import React, { useState, useEffect } from "react";
import { createDirectLine } from "botframework-webchat";
import { useLocation } from "react-router-dom";
import KWebChat from "./components/k-webchat/KWebChat";
import {
  buildEncryptedCredentialBody,
  buildApiHeaders,
  buildApiUrl,
  getQueryBootstrap,
  shouldWaitForApiBootstrap,
} from "./utils/apiBootstrap";

async function getDirectLineToken(chatId, apiBaseUrl) {
  const res = await fetch(buildApiUrl(apiBaseUrl, "/fetch_chat_info"), {
    method: "POST",
    headers: buildApiHeaders({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(buildEncryptedCredentialBody(chatId)),
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch Direct Line token: ${res.status}`);
  }

  const { token } = await res.json();
  return token;
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const WebChatContainerPlain = () => {
  const [directLine, setDirectLine] = useState();
  const [apiBootstrap, setApiBootstrap] = useState(() => getQueryBootstrap());
  const [bootstrapError, setBootstrapError] = useState("");
  const query = useQuery();
  const chatId = apiBootstrap.chatId;
  let isArabic = query.get("isArabic");
  if (isArabic === "true" || isArabic === true || isArabic === "True") {
    isArabic = true;
  } else {
    isArabic = false;
  }

  useEffect(() => {
    setApiBootstrap(() => getQueryBootstrap());
  }, [query.toString()]);

  useEffect(() => {
    const readyForApi = !shouldWaitForApiBootstrap(apiBootstrap);

    if (chatId && apiBootstrap.apiBaseUrl && readyForApi && !directLine) {
      getDirectLineToken(
        chatId,
        apiBootstrap.apiBaseUrl,
      ).then((token) => {
        const directLineConfig = { token };
        setDirectLine(createDirectLine(directLineConfig));
        setBootstrapError("");
      }).catch((error) => {
        console.error("Error initializing Direct Line:", error);
        setBootstrapError("Unable to connect to chat. Please refresh the page.");
      });
    }
  }, [apiBootstrap, chatId, directLine]);

  const loadingMessage = "Loading chat...";

  if (directLine) {
    return <KWebChat isArabic={isArabic} directLine={directLine} />;
  }

  return (
    <div className="flex h-full min-h-screen items-center justify-center bg-white px-6 text-center">
      <div className="max-w-md text-[#1f2937]">
        <div className="text-lg font-semibold">
          {bootstrapError || loadingMessage}
        </div>
        {!bootstrapError && (
          <div className="mt-2 text-sm text-[#6b7280]">
            The chat session is being prepared.
          </div>
        )}
      </div>
    </div>
  );
};

export default WebChatContainerPlain;
